export default "__VITE_ASSET__58556275__"